import { render, staticRenderFns } from "./UiItem.vue?vue&type=template&id=587a1393&"
import script from "./UiItem.vue?vue&type=script&lang=js&"
export * from "./UiItem.vue?vue&type=script&lang=js&"
import style0 from "./UiItem.vue?vue&type=style&index=0&id=587a1393&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports